// const API_BASE_URL = 'https://api.chemcoolx.com/v1/'; // prod

//removed to add the tesing local host link
// const API_BASE_URL = 'https://vishwtech-dev.iprotec.in/v1/'; // stage

// for local testing i have imported the localhost link

//  const API_BASE_URL =
//   process.env.REACT_APP_API_BASE_URL_LOCALHOST || "https://vishwtech-dev.iprotec.in/v1/";
// // http://localhost:4000/v1/auth/login

// const API_BASE_URL="http://13.126.147.224:3010/v1/"
// const API_BASE_URL = "http://192.168.0.188:3000/v1/"
const API_BASE_URL = process.env.REACT_APP_BACKEND_API_BASE_URL || "http://localhost:3000/v1/"
//API List
const apiEndpoints = {
  // Auth Related APIs
  AUTH_LOGIN: `${API_BASE_URL}auth/login`,

  // User Management APIs
  USER_LIST: `${API_BASE_URL}user/getalluser`,
  USER_CREATE: `${API_BASE_URL}user/createuser`,
  USER_UPDATE: `${API_BASE_URL}user/updateuser`,
  USER_DELETE: `${API_BASE_URL}user/deleteuser`,
  USER_BYID: `${API_BASE_URL}user/getuserbyid`,

  // Machine Management APIs
  MACHINE_LIST: `${API_BASE_URL}machine/getallmachine`,
  MACHINE_BYID: `${API_BASE_URL}machine/machinebyid`,
  MACHINE_CREATE: `${API_BASE_URL}machine/createmachine`,
  MACHINE_UPDATE: `${API_BASE_URL}machine/updatemachine`,
  MACHINE_BULK_UPLOAD: `${API_BASE_URL}machine/bulkupload`,
  MACHINE_LIST_BY_COMPANY: `${API_BASE_URL}dashboard/machinebycompanyid`,
  MACHINE_LIST_WITH_OIL_TYPE: `${API_BASE_URL}machine/getMachine`,
  MACHINE_DELETE: `${API_BASE_URL}machine/deletemachine`,

  // Company & Fluid Management APIs
  COMPANY_LIST: `${API_BASE_URL}company/getallcompanies`,
  COMPANY_CREATE: `${API_BASE_URL}company/createcompany`,
  COMPANY_UPDATE: `${API_BASE_URL}company/updateCompany`,
  COMPANY_BYID: `${API_BASE_URL}company/getcompanybyid`,
  COMPANY_DELETE: `${API_BASE_URL}company/deletecompany`,
  COMPANY_ADMIN_GET_ALL: `${API_BASE_URL}user/getallcompanyadmins`,
  FLUID_HANDLER_GET_ALL: `${API_BASE_URL}user/getallfluidhandlers`,
  //COMPANY_DELETE: `${API_BASE_URL}company/deletecompany`,  // dublicate

  // Oil Management APIs
  GET_ALL_OIL: `${API_BASE_URL}oil/getAll`,
  OIL_CREATE: `${API_BASE_URL}oil/add`,
  OIL_BYID: `${API_BASE_URL}oil/getAll?oil_id=`,
  OIL_UPDATE: `${API_BASE_URL}oil/update`,
  OIL_BY_COMPANY: `${API_BASE_URL}oil/getoilbycompany`,
  OIL_DELETE: `${API_BASE_URL}oil/deleteoil`,

  // Notification Management APIs
  NOTIFICATION_LIST: `${API_BASE_URL}notification/get`,
  NOTIFICATION_DELETE: `${API_BASE_URL}notification`,
  ALERT_NOTIFICATION: `${API_BASE_URL}notification/get`,
  NOTIFICATION_REPORT: `${API_BASE_URL}notification/list`,

  //Chart, report, library management APIs
  CHART_DATA: `${API_BASE_URL}dashboard/getchartdata`,
  REPORT_CREATE: `${API_BASE_URL}report/generatereport`,
  // Updated path for machine wise daily oil consumption (was generatedailyoilconsumptionreport)
  REPORT_DAILY_OIL_CONSUMPTION: `${API_BASE_URL}report/machinewise-daily-oil-consumption`,
  REPORT_YEARLY_WATER_CONSUMPTION: `${API_BASE_URL}report/yearly-machinewise-oil-consumption`, // water 
  // New API for machinewise monthly coolant oil consumption
  REPORT_MACHINEWISE_MONTHLY_COOLANT_OIL: `${API_BASE_URL}report/machinewise-monthly-coolant-oil-consumption`,
  // New oil-wise yearly consumption endpoint (takes oil_ids instead of machine_ids, no oil_type param needed)
  REPORT_YEARLY_OIL_CONSUMPTION: `${API_BASE_URL}report/yearly-oil-consumption`,
  // Coolant pH & Concentration daily data (pH + concentration per day)
  REPORT_DAILY_COOLANT_PH: `${API_BASE_URL}report/daywise-coolant-data`,
  LIBRARY_LIST: `${API_BASE_URL}library/getalllibrary`,
  ADD_LIBRARY: `${API_BASE_URL}library/add`,
  DELETE_LIBRARY: `${API_BASE_URL}library/delete`,

  // Banner Management APIs
  BANNER_LIST: `${API_BASE_URL}slider/getall`,
  BANNER_DELETE: `${API_BASE_URL}slider/delete`,
  BANNER_CREATE: `${API_BASE_URL}slider/add`,

  // Routine Work Management APIs
  ROUTINE_WORK_UPLOAD: `${API_BASE_URL}fh/routine_work/upload`,

};

export default apiEndpoints;
